import Button from '../../../components/Button';
import { useState } from 'react';
import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerAndroidScanningLibrary,
  CapacitorBarcodeScannerScanOrientation,
} from '@capacitor/barcode-scanner';
import { Html5QrcodeSupportedFormats } from 'html5-qrcode';

const ListBuilder = () => {
  const [urls, setUrls] = useState([]);

  const handleFormSubmit = async (data) => {
    const response = await getMetrics({
      startDate: data.startDate,
      endDate: data.endDate,
    });
    setMetrics(response.data);
  };

  const scannerHandler = async (currentUrls) => {
    const { ScanResult, format } = await CapacitorBarcodeScanner.scanBarcode({
      hint: Html5QrcodeSupportedFormats.QR_CODE,
      scanInstructions: 'Point at the QR',
      scanOrientation: CapacitorBarcodeScannerScanOrientation.PORTRAIT,
      android: {
        scanningLibrary: CapacitorBarcodeScannerAndroidScanningLibrary.MLKIT,
      },
    });
    if (ScanResult) {
      const newUrls = [...currentUrls, ScanResult];
      setUrls(newUrls);
      scannerHandler(newUrls);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
      <Button onClick={() => scannerHandler(urls)}>Add URL</Button>
      <Button onClick={() => navigator.clipboard.writeText(urls.join('\n'))}>
        Copy URLs
      </Button>
      <Button onClick={() => setUrls([])}>Reset URLs</Button>
      <div>
        {urls.map((url) => (
          <div>{url}</div>
        ))}
      </div>
    </div>
  );
};

export default ListBuilder;
